import { render, staticRenderFns } from "./ProductGeneralFields.vue?vue&type=template&id=06372cac&"
import script from "./ProductGeneralFields.vue?vue&type=script&lang=js&"
export * from "./ProductGeneralFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports